const STORAGE_KEY = 'paulseperformance_rpg_state';

export function loadState() {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    if (!data) return getDefaultState();
    return JSON.parse(data);
  } catch (error) {
    console.warn('Failed to load saved state, resetting.', error);
    return getDefaultState();
  }
}

export function saveState(state) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (error) {
    console.error('Failed to save state:', error);
  }
}

export function resetState() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Failed to reset state:', error);
  }
  return getDefaultState();
}

function getDefaultState() {
  return {
    xp: 0,
    level: 1,
    skillPoints: 0,
    unlockedSkills: [],
    achievements: [],
    cosmetics: ["default_outfit"]
  };
}